import {
    Component,
    Input,
    OnInit
} from '@angular/core';

@Component({
    selector: 'app-display-panel-body-line',
    templateUrl: './display-panel-body-line.component.html',
    styleUrls: ['./display-panel-body-line.component.scss']
})
export class DisplayPanelBodyLineComponent implements OnInit {

    @Input() propertyName = '';
    @Input() propertyValue = ' - ';
    addressFieldValue = false;
    constructor() { }

    ngOnInit() {
        if (!this.propertyValue || this.propertyValue === '') {
            this.propertyValue = ' - ';
        }

        this.addressFieldValue = this.propertyName.indexOf('Address') > -1;
    }

}
